module.exports = __webpack_public_path__ + "static/media/w-logo.803ecec7.png";